module.exports = __webpack_public_path__ + "img/22.152ddf9c.png";